export const PRICES = {
  individual: {
    id: "Rp 250.000 per sesi (60 menit) untuk konseling masalah pribadi atau gangguan emosional.",
    en: "Rp 250,000 per 60-minute session for personal or emotional counseling.",
  },
  couples: {
    id: "Konseling hubungan/relasi Rp 250.000 (60 menit, individu). Sesi bersama pasangan Rp 500.000 (90 menit); pasangan WNA Rp 600.000 (90 menit).",
    en: "Relationship counseling Rp 250,000 (60 min, individual). Joint couple sessions Rp 500,000 (90 min); mixed/foreign-national couples Rp 600,000 (90 min).",
  },
  family: {
    id: "Rp 250.000 per sesi (1 orang, 60 menit) hingga Rp 1.000.000 (5 anggota keluarga, 120 menit).",
    en: "From Rp 250,000 per session (1 person, 60 minutes) up to Rp 1,000,000 (5 family members, 120 minutes).",
  },
  child: {
    id: "Rp 250.000 per sesi 60 menit, termasuk konseling anak berkebutuhan khusus dan konseling pengasuhan (parenting).",
    en: "Rp 250,000 per 60-minute session, including counseling for children with special needs and parenting counseling.",
  },
  premarital: {
    id: "Konseling pranikah dengan pasangan Rp 500.000 per sesi 90 menit (pasangan WNA Rp 600.000).",
    en: "Premarital counseling with your partner: Rp 500,000 per 90-minute session (foreign-national couples Rp 600,000).",
  },
  marriage: {
    id: "Konseling pernikahan individu Rp 250.000 (60 menit); sesi bersama pasangan Rp 500.000 (90 menit).",
    en: "Individual marriage counseling Rp 250,000 (60 min); joint sessions with your partner Rp 500,000 (90 min).",
  },
  trauma: {
    id: "Rp 250.000 per sesi 60 menit.",
    en: "Rp 250,000 per 60-minute session.",
  },
  assessment: {
    id: "Tes IQ anak Rp 650.000 · Tes kesiapan Sekolah Dasar Rp 450.000 · Tes minat bakat SMP/SMA/SMK Rp 500.000 · Tes psikologi calon karyawan/pekerja migran Rp 400.000 · Pemeriksaan stres & kecemasan Rp 400.000 · Pemeriksaan tipe kepribadian Rp 500.000.",
    en: "Child IQ test Rp 650,000 · Primary school readiness test Rp 450,000 · Aptitude test (secondary students) Rp 500,000 · Pre-employment/migrant worker test Rp 400,000 · Stress & anxiety screening Rp 400,000 · Personality type screening Rp 500,000.",
  },
  programs: {
    id: "Biaya program bergantung pada kebutuhan dan struktur program Anda. Silakan tanyakan melalui WhatsApp di 087777430348.",
    en: "Program fees depend on your needs and the program structure. Please ask via WhatsApp at 087777430348.",
  },
  online: {
    id: "Biaya mengikuti jenis layanan konseling yang dipilih (mulai dari Rp 250.000 per sesi 60 menit). Konfirmasi biaya sesi online melalui WhatsApp di 087777430348.",
    en: "Fees follow the counseling service you choose (from Rp 250,000 per 60-minute session). Confirm online session fees via WhatsApp at 087777430348.",
  },
  offline: {
    id: "Biaya mengikuti jenis layanan konseling yang dipilih, mulai dari Rp 250.000 per sesi 60 menit di klinik.",
    en: "Fees follow the counseling service you choose, from Rp 250,000 per 60-minute in-clinic session.",
  },
};
